import React, { useRef, useEffect, useState } from "react";
import { Button ,FormControl,IconButton, InputLabel, MenuItem, Select, Box, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getStorage, ref, uploadBytes, getDownloadURL ,} from "firebase/storage";
import { useParams,useNavigate } from "react-router-dom";
import html2pdf from 'html2pdf.js';
import { jsPDF } from 'jspdf';
import autoTable from "jspdf-autotable";

import html2canvas from "html2canvas";
import { db ,storage} from "../../firebaseConfig.js";
import { doc, getDoc,setDoc } from "firebase/firestore";
import { toWords } from "number-to-words";
import logo from '../../../src/components/devangles-logo-150.png'
import './payslip.css';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmlToPdfmake from "html-to-pdfmake"; 
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const Payslip = () => {
    const INR = '₹';
  const { id } = useParams(); 
  const navigate = useNavigate(); 
  const storedId = localStorage.getItem("payslipEmployeeId") || id;
  const payslipRef = useRef();
  const [loading, setLoading] = useState(true);
  const [PayslipDetails, setPayslipDetails] = useState(null);
  const [payrollData, setPayrollData] = useState(null);
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  // const [payslipGenerated, setPayslipGenerated] = useState(false);
  const [payslipModified, setPayslipModified] = useState(false);
  const [employeeInfo, setEmployeeInfo] = useState(null);
const [bankDetails, setBankDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1 // Months are 0-indexed in JS
  });
  const [logoBase64, setLogoBase64] = useState("");

  useEffect(() => {
    const fetchBase64 = async () => {
      const response = await fetch(logo); // Assuming 'logo' is a local image
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => setLogoBase64(reader.result);
      reader.readAsDataURL(blob);
    };
    
    fetchBase64();
  }, []);
  
  const months = [
    { value: 1, name: "January" },
    { value: 2, name: "February" },
    { value: 3, name: "March" },
    { value: 4, name: "April" },
    { value: 5, name: "May" },
    { value: 6, name: "June" },
    { value: 7, name: "July" },
    { value: 8, name: "August" },
    { value: 9, name: "September" },
    { value: 10, name: "October" },
    { value: 11, name: "November" },
    { value: 12, name: "December" }
  ];
  
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    const fetchPayrollData = async () => {
      if (!storedId) return;
      
      setLoading(true);
      setNoDataAvailable(false);
  
      const formattedMonth = selectedDate.month.toString().padStart(2, '0');
      const dateString = `${selectedDate.year}-${formattedMonth}`;
      
      const payload = {
        email_id: localStorage.getItem("payslipEmployeeemail"),
        date: dateString
      };
  
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll`, {
          method: "POST",
          headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${accessToken}`},
          body: JSON.stringify(payload),
        });
  
        const data = await response.json();
  
        if (data.message?.includes("No payroll data")) {
          setNoDataAvailable(true);
          setPayrollData(null);
        } else {
          setPayrollData(data.payroll_data);
          setEmployeeInfo?.(data.employee_info);   // optional chaining to avoid errors if not used
    setBankDetails?.(data.bank_details);
        }
      } catch (error) {
        console.error("Error fetching payroll data:", error);
        setNoDataAvailable(true);
      } finally {
        setLoading(false);
      }
    };
  
    fetchPayrollData();
    checkPayslipExists();
  }, [storedId, selectedDate]);
  
  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (!storedId) {
        console.error("No Employee ID found.");
        setLoading(false);
        return;
      }
  
      try {
        // Fetch personal details
        const employeeRef = doc(db, "tbl_employee_personal_details", storedId);
        const employeeSnap = await getDoc(employeeRef);
  
        // Fetch bank details
        const bankRef = doc(db, "tbl_employee_bank_details", storedId);
        const bankSnap = await getDoc(bankRef);
  
        if (employeeSnap.exists()) {
          let employeeData = employeeSnap.data();
  
          if (bankSnap.exists()) {
            let bankData = bankSnap.data();
            employeeData = { ...employeeData, ...bankData }; // Merge both data
          }
  
          setPayslipDetails(employeeData);
        } else {
          console.error("No such employee found!");
        }
      } catch (error) {
        console.error("Error fetching employee details:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchEmployeeDetails();
    const formattedMonth = selectedDate.month.toString().padStart(2, '0');
    const dateString = `${selectedDate.year}-${formattedMonth}`;
     
    const payload = {
      "email_id": localStorage.getItem("payslipEmployeeemail"),
      "date": dateString
    }

    fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json','Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "No payroll data found for the given email_id and date") {
          setNoDataAvailable(true);
          setPayrollData({
            month_name: data.month_name,
            num_days: data.num_days
          });
        } else {
          setNoDataAvailable(false);
          setPayrollData(data.payroll_data);
        }
      })
      .catch((error) => {
        console.error("Error fetching payroll data:", error);
        setNoDataAvailable(true);
      });
  }, [storedId, selectedDate]);
  
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setSelectedDate(prev => ({
      ...prev,
      [name]: parseInt(value)
    }));
  };

  
  

  const checkPayslipExists = async () => {
    const storage = getStorage();
    const filePath = `payslips/${storedId}/${selectedDate.year}-${selectedDate.month}.pdf`;
    const storageRef = ref(storage, filePath);

    try {
      await getDownloadURL(storageRef);
      console.log("Payslip already exists in storage.");
      // setPayslipGenerated(true); // Enable download button
    } catch (error) {
      console.log("Payslip does not exist in storage.");
      // setPayslipGenerated(false); // Disable download button
    }
  };
  // Run the check when the component loads or when the selected date changes
  useEffect(() => {
    if (storedId && selectedDate) {
      checkPayslipExists();
    }
  }, [storedId, selectedDate]);

const compressPDFInBackend = async (pdfBlob) => {
    const formData = new FormData();
    formData.append("file", pdfBlob, "payslip.pdf");

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/compress-pdf`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        body: formData
      });

        if (!response.ok) throw new Error("Failed to compress PDF");

        return await response.blob(); // Return the compressed PDF
    } catch (error) {
        console.error("Error compressing PDF:", error);
        return pdfBlob; // Fallback: use original PDF if compression fails
    }
};


// const downloadPayslip = () => {
//   const content = document.getElementById('payslip-content');
//   const pdf = new jsPDF('p', 'mm', 'a4');

//   try {
//     pdf.html(content, {
//       callback: function (pdf) {
//         pdf.save(`payslip-${storedId}-${selectedDate.year}-${selectedDate.month}.pdf`);
//       },
//       x: 10,
//       y: 10,
//       width: 180,
//       windowWidth: 800,

//       // ✅ Ensure proper rendering of ₹ symbol without scaling
//       html2canvas: {
//         useCORS: true,
//         backgroundColor: "#ffffff",  // avoid transparent backgrounds
//         logging: false,              // silence console logs
//         fontFamily: 'Noto Sans',     // must be declared in CSS too
//       }
//     });
//   } catch (error) {
//     console.error("Error generating or downloading payslip:", error);
//     alert("Error generating or downloading payslip.");
//   }
// };
const downloadPayslip = async () => {


    const content = document.getElementById('payslip-content');

    // Enhanced HTML with print-friendly styles
    const fullHtml = `
    <html>
    <head>
      <style>
        @page {
          size: A4;
          margin: 30px;
        }
        body {
          font-family: Arial, sans-serif;
          color: black;
          margin: 5px;
          font-size: 15px;
        }
        table {
          width: 85%;
          max-width: 100%;
          border-collapse: collapse;
          margin-top: 2px;
          page-break-inside: auto;
          table-layout: fixed;
        }
        #payslip-content table {
        width: 85%;
        table-layout: fixed; /* Ensures fixed column widths */
      }
      th, td {
          border: 1px solid black;
          padding: 4px;
          text-align: left;
          font-size: 12px;
          word-wrap: break-word;
          overflow: hidden;
        }
      #salary th {
        background-color: #77B1D4 !important;
        color: black !important;
      }
      th {
          background-color: #f2f2f2;
          font-weight: bold;
        }
      #net-salary td {
        text-align: center;
        height: 20px;  /* Reduce row height */
        padding: 2px !important;  /* Reduce padding */
        line-height: 1 !important;  /* Reduce line spacing */
      }
      #net-salary-label {
        background-color: #77B1D4 !important; 
      }
      #net-salary-label td {
        text-align: center;
        height: 20px;
        padding: 2px !important;
        line-height: 1 !important;
      }
      #net-salary p {
        margin: 0 !important; /* Remove extra space */
      }
      #net-salary-words td{
        text-align: right;
        font-weight: bold;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap; /* Allow content to wrap instead of overflowing */
        width: 100%;
        max-width: 100%;
      }
      .header img {
        max-width: 220px; /* Reduce width slightly */
        height: 25px;
        margin-left: 10px;
      }
      .company-name {
        text-align: right;
        color: #0056b3;
        font-size: 18px; /* Reduce size slightly */
        font-weight: bold;
        max-width: 60%; /* Prevent excessive width */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 28px;
      }
    </style>
    </head>
    <body>
  <div id="payslip-content">

    <div class="header">
      <img src="${logoBase64}" />
      <h2 class="company-name">DevAngles Software Pvt Ltd</h2>
    </div> 
   ${content.innerHTML.replace(
          /<h2[^>]*>.*?DevAngles Software Pvt Ltd.*?<\/h2>/, 
          '' // Remove any existing company name
        )}
        
  </div>

    </body>
    </html>
`;
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/generate-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json','Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({ html_content: fullHtml }),
      });

      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `payslip-${storedId}-${selectedDate.year}-${selectedDate.month}.pdf`;
        link.click();
      } else {
        alert('Failed to generate PDF');
      }

    } catch (error) {
      console.error("Error generating or downloading payslip:", error);
      alert("Error generating or downloading payslip.");
    }
};
  const income = payrollData?.earnings
    ? Object.entries(payrollData.earnings).map(([key, value]) => ({
        name: key.replace(/_/g, " "), // Format field names
        amount: parseFloat(value) || 0,
      }))
    : [];

  const deductions = payrollData?.deductions
    ? Object.entries(payrollData.deductions).map(([key, value]) => ({
        name: key.replace(/_/g, " "),
        amount: parseFloat(value) || 0,
      }))
    : [];
  
    const filteredDeductions = deductions.filter(item => item.name !== "LOP" || item.amount !== 0);
    const maxRows = Math.max(income.length, filteredDeductions.length);

  const totalIncome = parseFloat(payrollData?.total_earnings) || 0;
  const totalDeductions = parseFloat(payrollData?.total_deductions) || 0;
  const netSalary = parseFloat(payrollData?.total_salary) || 0;
  const formattedMonthName = payrollData?.month_name || 
    `${months.find(m => m.value === selectedDate.month)?.name.substring(0, 3)}-${selectedDate.year}`;
    const [showPopup, setShowPopup] = useState(false);


  return (
    <div style={{ padding: "2px", fontFamily: "Arial, sans-serif", textAlign: "center", alignItems: "center" }}>
      <div style={{ textAlign:"left"}}>
        <IconButton onClick={() => navigate("/material/EmpList")} sx={{ mb: 2, color: "#1976d2" }}>
          <ArrowBackIcon />
        </IconButton>
      </div>

      <FormControl variant="outlined" size="small" sx={{ mr: 2 }}>
        <InputLabel>Month</InputLabel>
        <Select
          name="month"
          value={selectedDate.month}
          onChange={handleDateChange}
          label="Month"
        >
          {months.map((month) => (
            <MenuItem key={month.value} value={month.value}>
              {month.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <FormControl variant="outlined" size="small" sx={{ mr: 2 }}>
        <InputLabel>Year</InputLabel>
        <Select
          name="year"
          value={selectedDate.year}
          onChange={handleDateChange}
          label="Year"
        >
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <Button
        variant="contained"
        color="secondary"
        onClick={downloadPayslip}
        style={{ marginBottom: "0px" }}  
      >
        Download Payslip
      </Button>
       
  
      {noDataAvailable ? (
        <div> 
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "black" }}>
          <div style={popupStyles}>
            <h2 style={{ color: "#0056b3" }}>Payroll  Not Avilable</h2>
            <p>No Payroll Data Avilable for 0{selectedDate.month} / {selectedDate.year}  of  the {localStorage.getItem("payslipEmployeeemail")}</p>
        
        
          </div>
        </div>

        </div>
      ) : (
        <div id="payslip-content" style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "black" ,fontFamily: "'Noto Sans', 'Arial Unicode MS', 'Segoe UI', sans-serif"}}>
          
          <div ref={payslipRef} style={{ width: "800px",  padding: "15px", background: "#fff" }}>
            
            <div  style={{display:"flex", justifyContent:"space-between"}}>  
              <img src={logo}  style={{width:"220px" , height:"30px",marginTop:"25px"}}/>
            <h2 style={{ textAlign: "right", color: "#0056b3" }}>DevAngles Software Pvt Ltd</h2>
            
            </div>

            <table id="payslip-content" width="100%" 
            border="1.5" 
            cellPadding="5" 
            style={{ 
              borderCollapse: "collapse", 
              textAlign: "left",
              border: "2px solid black" ,
               
              }}>
              <tbody >
                <tr id="payslip-month" style={{ border: "1px solid black" }}>
                <td colSpan="3" style={{ paddingLeft: "10px",fontWeight: "bold",textAlign:'center' ,backgroundColor: "#77B1D4"}}>Salary Slip</td>
      
              <td  style={{ fontWeight: "bold", textAlign: "center",backgroundColor: "#77B1D4",width: "100px" }}>Month</td>
              <td  style={{ fontWeight: "bold", textAlign: "center",backgroundColor: "#77B1D4" }}>{payrollData?.month_name}</td>

                </tr>
                <tr id="employee-name"  style={{height:"10px"}}>
                  <td > Employee Name</td>
                  <td style={{ textAlign: 'center' }}>
                    {payrollData
                      ? `${employeeInfo?.name || ""}`
                      : "N/A"}
                  </td>
                  <td>Total Calendar Days</td>
                  <td colSpan="2" style={{ textAlign:'center'}}>{payrollData?.num_days}</td>
                </tr>
                <tr id="employee-name">
                  <td>Designation</td>
                  <td style={{ textAlign: 'center' }}>{employeeInfo?.designation || "N/A"}</td>
                  <td>Number of Days Paid</td>
                  <td  colSpan="2" style={{ textAlign:'center'}}>{payrollData?.actual_working_days}</td>
                </tr>
                <tr id="employee-name">
                  <td>Date of Joining</td>
                  <td style={{ textAlign: 'center' }}>{employeeInfo?.joining_date || "N/A"}</td>
                  <td>LOP Days</td>
                  <td  colSpan="2" style={{ textAlign:'center',fontWeight: "bold"}}> {payrollData?.LOP_DAYS}</td>
                </tr>
                <tr id="employee-name">
                  <td>PAN</td>
                  <td style={{ textAlign: 'center' }}>{bankDetails?.PAN_Number || "N/A"}</td>
                  <td>Leaves</td>
                   <td style={{ padding: "5px", borderRight: "1px solid black" ,textAlign:'center'}}>P</td>
                    <td style={{ padding: "5px",textAlign:'center' }}>S</td>
                </tr>
                <tr id="employee-name">
                <td>Bank Account Number</td>
                <td style={{ textAlign: 'center' }}>
                  {bankDetails?.Bank_Account_Number 
                    ? `XXXXXXXXXX${bankDetails?.Bank_Account_Number.slice(-4)}` 
                    : "N/A"}
                </td>

                  <td>Leave Opening Balance</td>
                  <td style={{ padding: "5px", borderRight: "1px solid black" ,textAlign:'center'}}>{payrollData?.actual_emergency_leave}</td>
                  <td style={{ padding: "5px" ,textAlign:'center'}}>{payrollData?.actual_planned_leave}</td>
                </tr>
                <tr id="employee-name">
              <td>Bank Name</td>
              <td style={{ textAlign: 'center' }}>{bankDetails?.Bank_Name || "N/A"}</td>
              <td>Leaves Taken</td>
              <td style={{ padding: "5px", borderRight: "1px solid black", textAlign: 'center', fontWeight: "bold" }}>
                {payrollData?.leave_summary?.PLANNED || 0}
              </td>
              <td style={{ padding: "5px", textAlign: 'center', fontWeight: "bold" }}>
                {payrollData?.leave_summary?.EMERGENCY || 0}
              </td>
            </tr >
            <tr id="employee-name">
              <td colSpan="2"></td>
              <td>Leave Closing Balance</td>
              <td style={{ padding: "5px", borderRight: "1px solid black", textAlign: 'center' }}>
                {payrollData?.subtracted_los_planned_leave || 0}
              </td>
              <td style={{ padding: "5px", textAlign: 'center' }}>
                {payrollData?.subtracted_los_emergency_leave || 0}
              </td>
            </tr>

            <tr >
              <td colSpan="5" style={{ height: "20px" }}></td> {/* Empty Row */}
            </tr>

            {/* Income & Deductions Section */}
            <tr id="salary">
              <th colSpan="2" style={{ textAlign: "center", fontWeight: "bold", backgroundColor: "#77B1D4" }}>Income</th>
              <th colSpan="3" style={{ textAlign: "center", fontWeight: "bold", backgroundColor: "#77B1D4" }}>Deductions</th>
            </tr>
            <tr id="salary" style={{  backgroundColor: "#77B1D4" }}>
              <th id="salary">Particulars</th>
              <th id="salary" style={{ textAlign: 'center',}}>Amount</th>
              <th id="salary">Particulars</th>
              <th id="salary" colSpan="2" style={{ textAlign: 'center',}}>Amount</th>
            </tr>
            {Array.from({ length: maxRows }).map((_, index) => (
            <tr id="salary" key={index}>
              <td>{income[index]?.name || ""}</td>
              <td style={{ textAlign: 'center' }}>
                {income[index] 
                  ? `₹${Math.round(income[index].amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : ""}
              </td>
              <td>{filteredDeductions[index]?.name || ""}</td>
              <td colSpan="2" style={{ textAlign: 'center' }}>
                {filteredDeductions[index] 
                  ? `₹${Math.round(filteredDeductions[index].amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : ""}
              </td>
            </tr>
          ))}

            <tr style={{ height: "30px" }}>
              <td></td> {/* Empty Row */}
              <td></td> 
              <td></td> 
              <td colSpan="2"></td> 
            </tr>

            {/* Total Row */}
            <tr id="salary" style={{ fontWeight: "bold" }}>
              <td>Total</td>
              <td style={{ textAlign: 'center' }}>
                ₹{Math.round(payrollData?.total_earnings || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </td>
              <td>Total</td>
              <td colSpan="2" style={{ textAlign: 'center' }}>
              ₹{Math.round(payrollData?.total_deductions || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>


            </tr>
            <tr id="salary">
              <td colSpan="5" style={{ height: "20px" }}></td> {/* Empty Row */}
            </tr>

            <tr id="net-salary" style={{ textAlign: "center",}}>
            <td  id="net-salary-label"  colSpan="3" style={{ 
            backgroundColor: "#77B1D4",  
            height: "30px", /* Reduce row height */
            padding: "2px", /* Reduce padding */
            lineHeight: "1", /* Reduce line spacing */
          }}><strong>Net Salary</strong></td>
                  <td   colSpan="2" style={{
            height: "30px",
            padding: "2px",
            lineHeight: "1",
          }}>
              <strong>
                <p style={{ margin: 0 }}>
                ₹{Math.round(payrollData?.total_salary || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p></strong>
            </td>
          </tr>

            {/* Net Salary in Words Row */}
            
        <tr id="net-salary-words"  style={{ textAlign: "right", fontWeight: "bold" }}>
                    <td id="net-salary-words" colSpan="5">
              <em>
                {toWords(Math.round(payrollData?.total_salary || 0)).replace(/\b\w/g, (char) => char.toUpperCase())}
              </em>
            </td>
          </tr>


            <tr>
              <td colSpan="5" style={{ height: "30px" }}></td> {/* Empty Row */}
            </tr>
            </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};


const popupStyles = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "300px",
  padding: "20px",
  background: "white",
  borderRadius: "10px",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  zIndex: 1000,
  textAlign: "center",
};



export default Payslip;
